/*
CopyRight: 2020 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
var name = 'ListView';
var keywords = ['Search'];
var category = 'navigation';
var meta = {
  keywords: keywords,
  name: name,
  category: category,
  "class": "Icon_".concat(name)
};
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#2867B2",
  x: "0",
  y: "0",
  width: "96",
  height: "96",
  rx: "6",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.000000, 13.000000)",
  fill: "#FFFFFF",
  "fill-rule": "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: "1",
  y: "22",
  width: "15",
  height: "47",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.2247247,26.8624699 C62.0519736,23.3774159 57.8396029,22 52.6222222,22 C50.6999112,22 48.9834704,22.1153914 47.4117635,22.5915939 C45.8405375,23.0674738 44.5837151,23.5122293 43.4222222,24.279259 C42.2607294,25.0462886 41.5150282,25.6239086 40.8747388,26.3604739 C40.2658707,27.060098 39.6399583,27.6656556 39.0589847,28.5875721 L39.0589847,23.3581171 L24,23.3581171 L24.0461701,25.5691035 C24.0771105,27.0433633 24.0923402,31.5872904 24.0923402,39.2015301 C24.0923402,46.816415 24.0618807,56.7489157 24.0006413,69 L39.0589847,69 L39.0589847,43.530424 C39.0589847,41.9648598 39.2258703,40.7216034 39.5622066,39.7996869 C40.2034579,38.2329935 41.1712664,36.9213395 42.4688383,35.8624664 C43.76625,34.8023027 45.4888112,34.4822884 47.4117635,34.4822884 C50.0351224,34.4822884 51.8522683,35.1860716 53.0882801,37.0129665 C54.323811,38.8397 54.9416566,41.3652511 54.9416566,44.5892971 L54.9416566,68.9985482 L70,68.9985482 L70,42.8403175 C69.9988778,36.1154086 68.3984375,30.3463947 65.2247247,26.8624699 Z",
  id: "Path",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.54543108,0 C6.00351011,0 3.94387181,0.80420934 2.36603343,2.41106104 C0.788355966,4.01826096 0,6.04732692 0,8.50017411 C0,10.9187218 0.76566599,12.9408234 2.29715889,14.5642155 C3.82816903,16.1877816 5.8499907,17 8.36149745,17 L8.4533838,17 C11.0265236,17 13.1019322,16.1884781 14.6791269,14.5642155 C16.2563216,12.9408234 17.0295509,10.9194183 16.9991367,8.50017411 C16.9685616,6.04750102 16.1869643,4.01826096 14.6559542,2.41106104 C13.125105,0.803512905 11.087513,0 8.54543108,0 Z",
  id: "Path",
  stroke: "none"
}))), meta);